import type { QueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query/queryKeys";

/**
 * Audit r1 A5-11: what an arrival-notice change outside the guest popup makes
 * stale — the settings page's contact list, every cached guest lookup of
 * the event (the popup's own / inherited links, staleTime 30 s) and the
 * automation editor's contact picker (plan arrival-automation Rev. 4 §1.4). The settings
 * page's event and role reads share the `notificationsPrefix` and stay
 * untouched, so a save there costs no extra event / role request.
 */
export function invalidateArrivalNoticeLookups(queryClient: QueryClient, eventId: string): Promise<unknown> {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: qk.eventSettings.notificationContacts(eventId) }),
    queryClient.invalidateQueries({ queryKey: qk.eventSettings.guestNotificationContactsPrefix(eventId) }),
    // plan arrival-automation Rev. 4 §1.4: the NOTIFY_CONTACT editor's picker.
    queryClient.invalidateQueries({ queryKey: qk.eventSettings.notificationContactPicker(eventId) }),
  ]);
}
